module.exports = __webpack_public_path__ + "img/restaurant-circle.31d39a44.svg";